/*!
 * Copyright (c) Microsoft Corporation and contributors. All rights reserved.
 * Licensed under the MIT License.
 */
import { convertSummaryTreeToWholeSummaryTree, } from "@fluidframework/server-services-client";
/**
 * Converts summary to snapshot tree and uploads with single snaphot tree payload.
 */
export class WholeSummaryUploadManager {
    constructor(manager) {
        this.manager = manager;
    }
    async writeSummaryTree(summaryTree, parentHandle, summaryType, sequenceNumber = 0, initial = false) {
        const id = await this.writeSummaryTreeCore(parentHandle, summaryTree, summaryType, sequenceNumber, initial);
        if (!id) {
            throw new Error(`Failed to write summary tree`);
        }
        return id;
    }
    async writeSummaryTreeCore(parentHandle, tree, type, sequenceNumber, initial) {
        const snapshotTree = convertSummaryTreeToWholeSummaryTree(parentHandle, tree, "", type === "channel" ? ".app" : "");
        const snapshotPayload = {
            entries: snapshotTree.entries ?? [],
            message: "",
            sequenceNumber,
            type,
        };
        return this.manager
            .createSummary(snapshotPayload, initial)
            .then((response) => response.content.id);
    }
}
//# sourceMappingURL=wholeSummaryUploadManager.js.map